module.exports = __webpack_public_path__ + "img/强风劲风.55a1b4fa.png";